import { Link } from 'react-router';
import { Card } from '../../components/ui';
import { useBadges } from '../../hooks/queries';
import { useT } from '../../i18n';
import { BadgeMedal } from './BadgeMedal';

/** Profile card: the earned badges at a glance, linking to the full list. */
export function BadgesCard({ userId, isMe }: { userId: string; isMe: boolean }) {
  const q = useBadges(isMe ? null : userId);
  const t = useT();
  const earned = q.data?.badges.filter((b) => b.tier > 0) ?? [];
  return (
    <Link
      to={isMe ? '/badges' : `/players/${userId}/badges`}
      className="mt-3 block active:opacity-80"
      data-testid="badges-card"
    >
      <Card>
        <div className="flex items-center justify-between">
          <h2 className="font-semibold">🏅 {t('Badges')}</h2>
          <span className="text-sm text-ink-400">
            {earned.length} / {q.data?.badges.length ?? '–'} ›
          </span>
        </div>
        {earned.length ? (
          <div className="mt-3 flex flex-wrap gap-1.5">
            {earned.map((b) => (
              <BadgeMedal key={b.id} id={b.id} tier={b.tier} size={40} />
            ))}
          </div>
        ) : (
          <p className="mt-2 text-sm text-ink-400">
            {isMe ? t('Run to unlock your first badge.') : t('No badges yet.')}
          </p>
        )}
      </Card>
    </Link>
  );
}
